import { createAction, createReducer } from '@reduxjs/toolkit';
import { IAction, IActionPartner } from './interface/apiInterface';
import { IInitialState } from './interface/reduxInterface';

const INITIAL_STATE: IInitialState = {
  isActive: false,
  isLoading: false,
  gotSuccess: false,
  gotError: false,
  partner: false,
  dateSearch: {
    start: '',
    end: '',
  },
  recebimento_transferencia_externa: {
    STR0004R2_FGTS: 0,
    STR0004R2_INVEST: 0,
    STR0006R2: 0,
    STR0007R2: 0,
    STR0008R2: 0,
    STR0010R2: 0,
    Pix: 0,
    Pix_Devolucao: 0,
  },
  envio_transferencia_externa: {
    STR0008: 0,
    Pix: 0,
    Pix_Devolucao: 0,
  },
  recebimento_domicilio_bancario: {
    ASLC022: 0,
    ASLC024: 0,
    ASLC032: 0,
  },
  envio_transferencia_interna: {
    STR0008: 0,
  },
  envio_transferencia_interna_conta_terceiros: {
    STR0008: 0,
  },
  recebimento_transferencia_interna_conta_fiducia: {
    STR0008: 0,
  },
  recebimento_tarifas: {
    TARIFA_PIX: 0,
    STR0004R2: 0,
    TAXA_TED: 0,
    TARIFA_BOLETO: 0,
    TARIFA: 0,
    TARIFA_BOLETO_VENCIDO: 0,
    TARIFA_CARTAO_SOLICITACAO: 0,
    TARIFA_MENSAL: 0,
    TARIFA_ALTERACAO_BOLETO: 0,
    TARIFA_BAIXADO: 0,
    TARIFA_ABERTURA_CONTA_PF: 0,
    TARIFA_ABERTURA_CONTA_PJ: 0,
    TARIFA_ABERTURA_CONTA_ESCROW: 0,
    TARIFA_ABERTURA_CONTA_CONSIGNADA: 0,
    TARIFA_RECEBIMENTO_PIX: 0,
    TARIFA_RECEBIMENTO_TED: 0,
    TARIFA_RECEBIMENTO_TEV: 0,
    TARIFA_RECEBIMENTO_BOLETO: 0,
    TARIFA_RECEBIMENTO_DOMICILIO: 0,
    TARIFA_RECEBIMENTO_PIX_DEVOLUCAO: 0,
    TARIFA_CRIPTO_VENDA: 0,
    TARIFA_CRIPTO_COMPRA: 0,
    TARIFA_CARTAO_SAQUE: 0,
    TARIFA_PIX_GERAR_QRCODE: 0,
  },
  repasse_tarifas: {
    TAXA_TED: 0,
    SLB0002: 0,
    STR0004: 0,
    TARIFA_PIX: 0,
    TARIFA_BOLETO: 0,
    TARIFA: 0,
    TARIFA_BOLETO_VENCIDO: 0,
    TARIFA_MENSAL: 0,
    TARIFA_ALTERACAO_BOLETO: 0,
    TARIFA_BAIXADO: 0,
    TARIFA_ABERTURA_CONTA_PF: 0,
    TARIFA_ABERTURA_CONTA_PJ: 0,
    TARIFA_ABERTURA_CONTA_ESCROW: 0,
    TARIFA_ABERTURA_CONTA_CONSIGNADA: 0,
    TARIFA_CARTAO_SOLICITACAO: 0,
    TARIFA_RECEBIMENTO_PIX: 0,
    TARIFA_CRIPTO_VENDA: 0,
    TARIFA_CRIPTO_COMPRA: 0,
    TARIFA_RECEBIMENTO_PIX_DEVOLUCAO: 0,
    TARIFA_CARTAO_SAQUE: 0,
    TARIFA_RECEBIMENTO_TED: 0,
    TARIFA_RECEBIMENTO_TEV: 0,
    TARIFA_RECEBIMENTO_BOLETO: 0,
    TARIFA_RECEBIMENTO_DOMICILIO: 0,
    TARIFA_PIX_GERAR_QRCODE: 0,
  },
  recebimento_boleto_fiducia: {
    BOLETO_CREDITO: 0,
  },
  recebimento_boleto_terceiros: {
    BOLETO_CREDITO: 0,
  },
  recebimento_boleto_itau: {
    BOLETO_CREDITO: 0,
  },
  pagamento_boleto: {
    Boleto: 0,
  },
  recebimento_boleto: {
    Boleto: 0,
    BOLETO_CREDITO: 0,
  },
  pagamento_recarga: {
    Recarga: 0,
  },
  recebimento_recarga: {
    Recarga: 0,
  },
  envio_cartao: {
    CARTAO_00_PURCHASE: 0,
    CARTAO_01_CASH_WITHDRAW: 0,
  },
  recebimento_cartao: {
    CARTAO_00_PURCHASE: 0,
    CARTAO_01_CASH_WITHDRAW: 0,
  },
};

export const getClosedDataFromApi = createAction(
  '@accountingApp/closedData/GET_ANALITIC_DATA_FROM_API'
);

export const gotClosedDataFromApi = createAction<any>(
  '@accountingApp/closedData/GOT_ANALITIC_DATA_FROM_API'
);

export const gotClosedDataPartnerFromApi = createAction<any>(
  '@accountingApp/closedData/GOT_ANALITICPARTNER_DATA_FROM_API'
);

export const gotErrorFromClosedDataApi = createAction(
  '@accountingApp/closedData/GOT_ERROR_FROM_ANALITIC_DATA_API'
);

const closedDataReducer = createReducer(INITIAL_STATE, {
  [getClosedDataFromApi.type]: (state) => ({
    ...state,
    isActive: false,
    gotSuccess: false,
    partner: false,
    gotError: false,
    isLoading: true,
  }),
  [gotClosedDataFromApi.type]: (state, action: IAction) => ({
    ...state,
    isActive: true,
    gotSuccess: true,
    isLoading: false,
    gotError: false,
    partner: false,
    dateSearch: {
      start: action.payload.data_de_pesquisa.de,
      end: action.payload.data_de_pesquisa.ate,
    },
    recebimento_transferencia_externa: {
      STR0004R2_INVEST:
        action.payload.recebimento_transferencia_externa.STR0004R2_INVEST,
      STR0006R2: action.payload.recebimento_transferencia_externa.STR0006R2,
      STR0007R2: action.payload.recebimento_transferencia_externa.STR0007R2,
      STR0008R2: action.payload.recebimento_transferencia_externa.STR0008R2,
      STR0010R2: action.payload.recebimento_transferencia_externa.STR0010R2,
      Pix: action.payload.recebimento_transferencia_externa.Pix,
      STR0004R2_FGTS:
        action.payload.recebimento_transferencia_externa.STR0004R2_FGTS,
      Pix_Devolucao:
        action.payload.recebimento_transferencia_externa.Pix_Devolucao,
    },
    envio_transferencia_externa: {
      STR0008: action.payload.envio_transferencia_externa.STR0008,
      Pix: action.payload.envio_transferencia_externa.Pix,
      Pix_Devolucao: action.payload.envio_transferencia_externa.Pix_Devolucao,
    },
    recebimento_domicilio_bancario: {
      ASLC022: action.payload.recebimento_domicilio_bancario.ASLC022,
      ASLC024: action.payload.recebimento_domicilio_bancario.ASLC024,
      ASLC032: action.payload.recebimento_domicilio_bancario.ASLC032,
    },
    envio_transferencia_interna: {
      STR0008: action.payload.envio_transferencia_interna.STR0008,
    },
    envio_transferencia_interna_conta_terceiros: {
      STR0008:
        action.payload.envio_transferencia_interna_conta_terceiros.STR0008,
    },
    recebimento_transferencia_interna_conta_fiducia: {
      STR0008:
        action.payload.recebimento_transferencia_interna_conta_fiducia.STR0008,
    },
    recebimento_tarifas: {
      TARIFA_PIX: action.payload.recebimento_tarifas.TARIFA_PIX,
      STR0004R2: action.payload.recebimento_tarifas.STR0004R2,
      TAXA_TED: action.payload.recebimento_tarifas.TAXA_TED,
      TARIFA_BOLETO: action.payload.recebimento_tarifas.TARIFA_BOLETO,
      TARIFA: action.payload.recebimento_tarifas.TARIFA,
      TARIFA_BOLETO_VENCIDO:
        action.payload.recebimento_tarifas.TARIFA_BOLETO_VENCIDO,
      TARIFA_MENSAL: action.payload.recebimento_tarifas.TARIFA_MENSAL,
      TARIFA_ALTERACAO_BOLETO:
        action.payload.recebimento_tarifas.TARIFA_ALTERACAO_BOLETO,
      TARIFA_BAIXADO: action.payload.recebimento_tarifas.TARIFA_BAIXADO,
      TARIFA_CARTAO_SOLICITACAO:
        action.payload.recebimento_tarifas.TARIFA_CARTAO_SOLICITACAO,
      TARIFA_ABERTURA_CONTA_PF:
        action.payload.recebimento_tarifas.TARIFA_ABERTURA_CONTA_PF,
      TARIFA_ABERTURA_CONTA_PJ:
        action.payload.recebimento_tarifas.TARIFA_ABERTURA_CONTA_PJ,
      TARIFA_ABERTURA_CONTA_ESCROW:
        action.payload.recebimento_tarifas.TARIFA_ABERTURA_CONTA_ESCROW,
      TARIFA_ABERTURA_CONTA_CONSIGNADA:
        action.payload.recebimento_tarifas.TARIFA_ABERTURA_CONTA_CONSIGNADA,
      TARIFA_RECEBIMENTO_TED:
        action.payload.recebimento_tarifas.TARIFA_RECEBIMENTO_TED,
      TARIFA_RECEBIMENTO_TEV:
        action.payload.recebimento_tarifas.TARIFA_RECEBIMENTO_TEV,
      TARIFA_RECEBIMENTO_BOLETO:
        action.payload.recebimento_tarifas.TARIFA_RECEBIMENTO_BOLETO,
      TARIFA_RECEBIMENTO_DOMICILIO:
        action.payload.recebimento_tarifas.TARIFA_RECEBIMENTO_DOMICILIO,
      TARIFA_RECEBIMENTO_PIX:
        action.payload.recebimento_tarifas.TARIFA_RECEBIMENTO_PIX,
      TARIFA_RECEBIMENTO_PIX_DEVOLUCAO:
        action.payload.recebimento_tarifas.TARIFA_RECEBIMENTO_PIX_DEVOLUCAO,
      TARIFA_CRIPTO_VENDA:
        action.payload.recebimento_tarifas.TARIFA_CRIPTO_VENDA,
      TARIFA_CRIPTO_COMPRA:
        action.payload.recebimento_tarifas.TARIFA_CRIPTO_COMPRA,
      TARIFA_CARTAO_SAQUE:
        action.payload.recebimento_tarifas.TARIFA_CARTAO_SAQUE,
      TARIFA_PIX_GERAR_QRCODE:
        action.payload.recebimento_tarifas.TARIFA_PIX_GERAR_QRCODE,
    },
    repasse_tarifas: {
      TAXA_TED: action.payload.repasse_tarifas.TAXA_TED,
      SLB0002: action.payload.repasse_tarifas.SLB0002,
      STR0004: action.payload.repasse_tarifas.STR0004,
      TARIFA_PIX: action.payload.repasse_tarifas.TARIFA_PIX,
      TARIFA_BOLETO: 0,
      TARIFA: 0,
      TARIFA_BOLETO_VENCIDO: 0,
      TARIFA_MENSAL: 0,
      TARIFA_ALTERACAO_BOLETO: 0,
      TARIFA_BAIXADO: 0,
      TARIFA_ABERTURA_CONTA_PF: 0,
      TARIFA_ABERTURA_CONTA_PJ: 0,
      TARIFA_ABERTURA_CONTA_ESCROW: 0,
      TARIFA_ABERTURA_CONTA_CONSIGNADA: 0,
      TARIFA_RECEBIMENTO_PIX: 0,
      TARIFA_RECEBIMENTO_PIX_DEVOLUCAO: 0,
      TARIFA_CRIPTO_VENDA: 0,
      TARIFA_CRIPTO_COMPRA: 0,
      TARIFA_CARTAO_SAQUE: 0,
      TARIFA_RECEBIMENTO_TED: 0,
      TARIFA_RECEBIMENTO_TEV: 0,
      TARIFA_RECEBIMENTO_BOLETO: 0,
      TARIFA_RECEBIMENTO_DOMICILIO: 0,
      TARIFA_CARTAO_SOLICITACAO: 0,
      TARIFA_PIX_GERAR_QRCODE: 0,
    },
    recebimento_boleto_fiducia: {
      BOLETO_CREDITO: action.payload.recebimento_boleto_fiducia.BOLETO_CREDITO,
    },
    recebimento_boleto_terceiros: {
      BOLETO_CREDITO:
        action.payload.recebimento_boleto_terceiros.BOLETO_CREDITO,
    },
    recebimento_boleto_itau: {
      BOLETO_CREDITO: action.payload.recebimento_boleto_itau.BOLETO_CREDITO,
    },
    pagamento_boleto: {
      Boleto: action.payload.pagamento_boleto.Boleto,
    },
    recebimento_boleto: {
      Boleto: action.payload.recebimento_boleto.Boleto,
      BOLETO_CREDITO: 0,
    },
    pagamento_recarga: {
      Recarga: action.payload.pagamento_recarga.Recarga,
    },
    recebimento_recarga: {
      Recarga: action.payload.recebimento_recarga.Recarga,
    },
    envio_cartao: {
      CARTAO_00_PURCHASE: action.payload.envio_cartao.CARTAO_00_PURCHASE,
      CARTAO_01_CASH_WITHDRAW:
        action.payload.envio_cartao.CARTAO_01_CASH_WITHDRAW,
    },
    recebimento_cartao: {
      CARTAO_00_PURCHASE: action.payload.recebimento_cartao.CARTAO_00_PURCHASE,
      CARTAO_01_CASH_WITHDRAW:
        action.payload.recebimento_cartao.CARTAO_01_CASH_WITHDRAW,
    },
  }),
  [gotClosedDataPartnerFromApi.type]: (state, action: IActionPartner) => ({
    ...state,
    gotSuccess: true,
    isActive: true,
    isLoading: false,
    gotError: false,
    partner: true,
    dateSearch: {
      start: action.payload.data_de_pesquisa.de,
      end: action.payload.data_de_pesquisa.ate,
    },
    recebimento_transferencia_externa: {
      STR0007R2: action.payload.recebimento_transferencia_externa.STR0007R2,
      STR0008R2: action.payload.recebimento_transferencia_externa.STR0008R2,
      STR0006R2: action.payload.recebimento_transferencia_externa.STR0006R2,
      STR0010R2: action.payload.recebimento_transferencia_externa.STR0010R2,
      Pix: action.payload.recebimento_transferencia_externa.Pix,
      Pix_Devolucao:
        action.payload.recebimento_transferencia_externa.Pix_Devolucao,
    },
    envio_transferencia_externa: {
      STR0008: action.payload.envio_transferencia_externa.STR0008,
      Pix: action.payload.envio_transferencia_externa.Pix,
      Pix_Devolucao: action.payload.envio_transferencia_externa.Pix_Devolucao,
    },
    recebimento_domicilio_bancario: {
      ASLC022: action.payload.recebimento_domicilio_bancario.ASLC022,
      ASLC024: action.payload.recebimento_domicilio_bancario.ASLC024,
      ASLC032: action.payload.recebimento_domicilio_bancario.ASLC032,
    },
    envio_transferencia_interna: {
      STR0008: action.payload.envio_transferencia_interna.STR0008,
    },
    recebimento_transferencia_interna_conta_fiducia: {
      STR0008:
        action.payload.recebimento_transferencia_interna_conta_fiducia.STR0008,
    },
    recebimento_tarifas: {
      TARIFA_PIX: action.payload.recebimento_tarifas.TARIFA_PIX,
      STR0004R2: 0,
      TAXA_TED: action.payload.recebimento_tarifas.TAXA_TED,
      TARIFA_BOLETO: action.payload.recebimento_tarifas.TARIFA_BOLETO,
      TARIFA: 0,
      TARIFA_BOLETO_VENCIDO: 0,
      TARIFA_MENSAL: action.payload.recebimento_tarifas.TARIFA_MENSAL,
      TARIFA_ALTERACAO_BOLETO: 0,
      TARIFA_BAIXADO: 0,
      TARIFA_CARTAO_SOLICITACAO:
        action.payload.recebimento_tarifas.TARIFA_CARTAO_SOLICITACAO,
      TARIFA_ABERTURA_CONTA_PF:
        action.payload.recebimento_tarifas.TARIFA_ABERTURA_CONTA_PF,
      TARIFA_ABERTURA_CONTA_PJ:
        action.payload.recebimento_tarifas.TARIFA_ABERTURA_CONTA_PJ,
      TARIFA_ABERTURA_CONTA_ESCROW:
        action.payload.recebimento_tarifas.TARIFA_ABERTURA_CONTA_ESCROW,
      TARIFA_ABERTURA_CONTA_CONSIGNADA:
        action.payload.recebimento_tarifas.TARIFA_ABERTURA_CONTA_CONSIGNADA,
      TARIFA_RECEBIMENTO_PIX:
        action.payload.recebimento_tarifas.TARIFA_RECEBIMENTO_PIX,
      TARIFA_RECEBIMENTO_PIX_DEVOLUCAO:
        action.payload.recebimento_tarifas.TARIFA_RECEBIMENTO_PIX_DEVOLUCAO,
      TARIFA_RECEBIMENTO_TED:
        action.payload.recebimento_tarifas.TARIFA_RECEBIMENTO_TED,
      TARIFA_RECEBIMENTO_TEV:
        action.payload.recebimento_tarifas.TARIFA_RECEBIMENTO_TEV,
      TARIFA_RECEBIMENTO_BOLETO:
        action.payload.recebimento_tarifas.TARIFA_RECEBIMENTO_BOLETO,
      TARIFA_RECEBIMENTO_DOMICILIO:
        action.payload.recebimento_tarifas.TARIFA_RECEBIMENTO_DOMICILIO,
      TARIFA_CRIPTO_VENDA:
        action.payload.recebimento_tarifas.TARIFA_CRIPTO_VENDA,
      TARIFA_CRIPTO_COMPRA:
        action.payload.recebimento_tarifas.TARIFA_CRIPTO_COMPRA,
      TARIFA_CARTAO_SAQUE:
        action.payload.recebimento_tarifas.TARIFA_CARTAO_SAQUE,
      TARIFA_PIX_GERAR_QRCODE:
        action.payload.recebimento_tarifas.TARIFA_PIX_GERAR_QRCODE,
    },
    repasse_tarifas: {
      TAXA_TED: action.payload.repasse_tarifas.TAXA_TED,
      TARIFA_PIX: action.payload.repasse_tarifas.TARIFA_PIX,
      TARIFA_BOLETO: action.payload.repasse_tarifas.TARIFA_BOLETO,
      TARIFA: action.payload.repasse_tarifas.TARIFA,
      TARIFA_BOLETO_VENCIDO:
        action.payload.repasse_tarifas.TARIFA_BOLETO_VENCIDO,
      TARIFA_MENSAL: action.payload.repasse_tarifas.TARIFA_MENSAL,
      TARIFA_ALTERACAO_BOLETO:
        action.payload.repasse_tarifas.TARIFA_ALTERACAO_BOLETO,
      TARIFA_BAIXADO: action.payload.repasse_tarifas.TARIFA_BAIXADO,
      TARIFA_ABERTURA_CONTA_PF:
        action.payload.repasse_tarifas.TARIFA_ABERTURA_CONTA_PF,
      TARIFA_ABERTURA_CONTA_PJ:
        action.payload.repasse_tarifas.TARIFA_ABERTURA_CONTA_PJ,
      TARIFA_ABERTURA_CONTA_ESCROW:
        action.payload.repasse_tarifas.TARIFA_ABERTURA_CONTA_ESCROW,
      TARIFA_ABERTURA_CONTA_CONSIGNADA:
        action.payload.repasse_tarifas.TARIFA_ABERTURA_CONTA_CONSIGNADA,
      TARIFA_CARTAO_SOLICITACAO:
        action.payload.repasse_tarifas.TARIFA_CARTAO_SOLICITACAO,
      TARIFA_RECEBIMENTO_PIX:
        action.payload.repasse_tarifas.TARIFA_RECEBIMENTO_PIX,
      TARIFA_CRIPTO_VENDA: action.payload.repasse_tarifas.TARIFA_CRIPTO_VENDA,
      TARIFA_CRIPTO_COMPRA: action.payload.repasse_tarifas.TARIFA_CRIPTO_COMPRA,
      TARIFA_RECEBIMENTO_PIX_DEVOLUCAO:
        action.payload.repasse_tarifas.TARIFA_RECEBIMENTO_PIX_DEVOLUCAO,
      TARIFA_PIX_GERAR_QRCODE:
        action.payload.repasse_tarifas.TARIFA_PIX_GERAR_QRCODE,
      TARIFA_RECEBIMENTO_TED:
        action.payload.repasse_tarifas.TARIFA_RECEBIMENTO_TED,
      TARIFA_RECEBIMENTO_TEV:
        action.payload.repasse_tarifas.TARIFA_RECEBIMENTO_TEV,
      TARIFA_RECEBIMENTO_BOLETO:
        action.payload.repasse_tarifas.TARIFA_RECEBIMENTO_BOLETO,
      TARIFA_RECEBIMENTO_DOMICILIO:
        action.payload.repasse_tarifas.TARIFA_RECEBIMENTO_DOMICILIO,
      SLB0002: 0,
      STR0004: 0,
    },
    recebimento_boleto_fiducia: {
      BOLETO_CREDITO: 0,
    },
    recebimento_boleto_terceiros: {
      BOLETO_CREDITO: 0,
    },
    recebimento_boleto_itau: {
      BOLETO_CREDITO: 0,
    },
    pagamento_boleto: {
      Boleto: action.payload.pagamento_boleto.Boleto,
    },
    recebimento_boleto: {
      Boleto: 0,
      BOLETO_CREDITO: action.payload.recebimento_boleto.BOLETO_CREDITO,
    },
    pagamento_recarga: {
      Recarga: action.payload.pagamento_recarga.Recarga,
    },
    recebimento_recarga: {
      Recarga: 0,
    },
    envio_cartao: {
      CARTAO_00_PURCHASE: action.payload.envio_cartao.CARTAO_00_PURCHASE,
      CARTAO_01_CASH_WITHDRAW:
        action.payload.envio_cartao.CARTAO_01_CASH_WITHDRAW,
    },
    recebimento_cartao: {
      CARTAO_00_PURCHASE: 0,
      CARTAO_01_CASH_WITHDRAW: 0,
    },
  }),
  [gotErrorFromClosedDataApi.type]: (state) => ({
    ...state,
    gotSuccess: false,
    isLoading: false,
    partner: false,
    gotError: true,
  }),
});

export default closedDataReducer;
